import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "@/features/Table";
import { type K2DataUpload, data_upload_columns } from "./columns";
import UploadPopover from "@/components/UploadPopover";
import { type FilterK2DataUploadSchema, K2DataUploadFilter } from "./filter";
import { K2DataUploadNew } from "./new";
import { useQueryClient } from "@tanstack/react-query";

export const K2DataUploadTable = () => {
  const [searchParams] = useSearchParams();
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const client = searchParams.get("client") || "k2";
  const table_name = "k2_data_upload";

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    // In v5, this invalidates all queries whose key starts with the prefix
    await QueryClient.invalidateQueries({
      queryKey: [client, table_name, "get"],
    });
  };

  return (
    <Table<K2DataUpload, FilterK2DataUploadSchema>
      label="Chargement de fichiers"
      client={client}
      table_name={table_name}
      columns={data_upload_columns}
      filter={<K2DataUploadFilter />}
      disable_translations_request={true}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <K2DataUploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
